import { Route } from "react-router-dom";
import { GoldScreen } from "./GoldScreen";

export const routes = (
  <>
    <Route index path="gold/*" Component={GoldScreen} />
    <Route index path="gold-app/*" Component={GoldScreen} />
  </>
);
